import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Announcement from './Announcement';
import Nav from './Nav';
import MobileNav from './MobileNav';
import Footer from './Footer';
import AskFab from './AskFab';
import { isAuthPath } from '../../routes.manifest';

export default function SiteShell({ showAskFab = true }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollProg, setScrollProg] = useState('0%');
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 4);
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProg(`${h > 0 ? (window.scrollY / h) * 100 : 0}%`);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const flash = () => {
      const id = location.hash.slice(1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      el.classList.remove('flash-target');
      void el.offsetWidth;
      el.classList.add('flash-target');
    };
    if (location.hash) setTimeout(flash, 120);
  }, [location.hash, location.pathname]);

  /* Sign-in, sign-up and the rest of the auth screens fill the viewport with
     their own split layout and carry their own brand mark. All the marketing
     chrome — promo bar, nav, footer, the Ask TeamGrid bubble — is dropped
     there: it competes with the one thing the page is asking you to do, and
     the promo bar in particular invites people straight back out of a form
     they'd started. See AUTH_PATHS in routes.manifest.js. */
  const auth = isAuthPath(location.pathname);

  return (
    <div className={`tg-landing${auth ? ' tg-auth' : ''}`}>
      {!auth && (
        <>
          <Announcement />
          <Nav
            onMenuOpen={() => setMenuOpen(true)}
            scrolled={scrolled}
            scrollProg={scrollProg}
          />
        </>
      )}

      <Outlet />

      {!auth && (
        <>
          <Footer />
          <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} />
          {showAskFab ? <AskFab /> : null}
        </>
      )}
    </div>
  );
}
